export default {
	SET_PITCHES_LIST(state, pitches){
		state.list = pitches
	}, 
	SET_SELECTION(state, pitches){
		state.selection = pitches
	}
}